/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

const is = require("is_js");

const SERVICE_NAME = "CreateDiscountPageService";
const log: any = LoggerModule.getInstance();

export class CreateDiscountPageService {
  private static instance: CreateDiscountPageService;
  private vapp: VApplication;
  private loginRestAPI: string;
  private headers: any;
  private token: string;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
    this.loginRestAPI = props?.loginRestAPI;
    this.headers = props?.headers;
    this.token = props?.token;
  }

  public static getInstance(props: any = {}): CreateDiscountPageService {
    if (!CreateDiscountPageService.instance) {
      CreateDiscountPageService.instance = new CreateDiscountPageService(props);
    }
    return CreateDiscountPageService.instance;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPresentationWithCoupons(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getPresentationListsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }

    compProps = await agent.getCouponsProps({ ...args, compProps });
    if (compProps) {
      content = { ...content, ...compProps };
    }
    console.log(`content=================>`, content);
    return content;
  }

  public async getCouponsProps(args?: any) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getCouponsProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async createCoupon(args?: any) {
    console.log(args, "Args678");
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.getCreateCouponProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async updateCoupon(args?: any) {
    console.log(args, "Args67888888888");
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = await agent.updateCouponProps(args);
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }
}
